import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Image from '../../../../Image';
import { transformPrompt } from '../../../../../utils';
import { ROW_LABEL_CLASSNAME } from '../constants';
import useToggle from '../hooks/useToggle';
import Columns from './Columns';

export default function OpenEndedText({
  rows,
  openEndedStyle,
  openEndedInputSize,
  minLength,
  maxLength,
  showRequiredInputSymbol,
  getText,
}) {
  const { onClickRowLabel, onBlurToggle } = useToggle('textarea');
  const lastIndex = rows.length - 1;

  return (
    <div className="answers">
      {rows.map((row, index) => {
        const isEmptyLabel = !row.label || row.label === '<div></div>';

        return (
          <Fragment>
            <div
              id={row.id}
              className="answer--matrix-open-ended"
              onBlur={onBlurToggle}
              data-testid="matrix-row"
            >
              {!isEmptyLabel && (
                <button
                  type="button"
                  className={ROW_LABEL_CLASSNAME}
                  onClick={onClickRowLabel}
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: transformPrompt(row.label) || '&nbsp;',
                  }}
                />
              )}
              <div className="answer--matrix-open-ended-content-wrapper">
                <Image row={row} />
                <Columns
                  rowId={row.id}
                  rowRefId={row.refId}
                  rowOrder={index}
                  columns={row.columns}
                  openEndedStyle={openEndedStyle}
                  openEndedInputSize={openEndedInputSize}
                  minLength={minLength}
                  maxLength={maxLength}
                  showRequiredInputSymbol={showRequiredInputSymbol}
                />
              </div>
            </div>
            {lastIndex > index && <div className="divider margin-md"></div>}
          </Fragment>
        );
      })}
      {!showRequiredInputSymbol && (
        <div className="answer--matrix-open-ended-info-message-missing" />
      )}
      {showRequiredInputSymbol && (
        <span className="answer--matrix-open-ended-info-message">
          <span>* {getText('warnings.matrixNumericOpenEndedNote')}</span>
        </span>
      )}
    </div>
  );
}

OpenEndedText.propTypes = {
  rows: PropTypes.array,
  openEndedStyle: PropTypes.string,
  openEndedInputSize: PropTypes.string,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  showRequiredInputSymbol: PropTypes.bool,
  getText: PropTypes.func,
};
